import { Reveal } from "../../components/Motion";
import EnquiryForm from "../../components/EnquiryForm";
import { pick } from "../../lib/leadFields";

const FIELDS = pick("name", "phone", "business_type", "product", "quantity", "city");

export default function QuickEnquiry() {
  return (
    <section data-testid="home-quick-enquiry" className="relative overflow-hidden bg-navy py-24 text-white grain md:py-32">
      <div className="absolute inset-0 grid-lines" />
      <div className="relative mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow text-brand">Get a quote</p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.92] md:text-6xl">Need AdBlue? Tell us in 30 seconds.</h2>
          <p className="mt-6 max-w-md text-slate-300">Share your requirement and our team will call or WhatsApp you with price and availability.</p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="rounded-[26px] bg-white p-6 text-navy sm:p-10">
            <EnquiryForm type="home" testPrefix="home-enquiry" fields={FIELDS} submitLabel="Get my quote" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
